import { render, staticRenderFns } from "./CtName.vue?vue&type=template&id=5f49d79e&scoped=true&"
import script from "./CtName.vue?vue&type=script&lang=js&"
export * from "./CtName.vue?vue&type=script&lang=js&"
import style0 from "./CtName.vue?vue&type=style&index=0&id=5f49d79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49d79e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
